<template>
  <div id="app">
    <HeaderWrap></HeaderWrap>
    <router-view />
    <FooterWrap></FooterWrap>
  </div>
</template>
<script>
import HeaderWrap from './components/Layout/HeaderWrap'
import FooterWrap from './components/Layout/FooterWrap'
export default {
  components: {
    HeaderWrap,
    FooterWrap
  }
}
</script>
<style lang="less">
#app {
  position: relative;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1200px;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.lazy-animate-init {
  visibility: hidden;
  transform: translateY(50px);
  opacity: 0;

  &.lazy-animate-run {
    transition: transform 0.5s ease, opacity 0.5s linear;
    visibility: visible;
    opacity: 1;
    transform: none;
  }
}
</style>
